import React, { ReactNode, useCallback } from 'react';
import { NextPage } from 'next';
import { defineMessages, useIntl } from 'react-intl';
import { BlogPostsResponse } from './blogPosts';
import { BlogBase } from './BlogBase';
import { BlogPostListItemView } from './BlogPostListItemView';
import { BlogPagination } from './BlogPagination';
import { DeviceType } from '../../components/types';
import { makePageTitle } from '../../components/utils';
import { BlogUpselling } from './BlogUpselling';

const { pageTitle } = defineMessages({
  pageTitle: {
    id: 'sml.web.blog.page_title',
    defaultMessage: 'Blog'
  }
});

export interface BlogPostsPage {
  blogPosts: BlogPostsResponse;
  limit: number;
  currentPage: number;
  deviceType: DeviceType;
}

export const BlogPostsPage: NextPage<BlogPostsPage> = React.memo<BlogPostsPage>(
  ({ blogPosts: { meta, data }, limit, currentPage, deviceType }) => {
    const intl = useIntl();

    const getPaginationURL = useCallback((page: number) => {
      const pathName = '/blog';
      let as = `/blog`;
      if (page) {
        as += `?page=${page}`;
      }
      return {
        href: { pathname: pathName, query: { page } },
        as
      };
    }, []);

    const insertUpSellingAfterNumberOfPosts = 3;

    let listElementsFirstPart: ReactNode = null;
    let listElementsSecondPart: ReactNode = null;
    const listElements = data.map((blogPost) => (
      <BlogPostListItemView key={blogPost.attributes.slug} post={blogPost} />
    ));
    if (listElements.length === limit) {
      listElementsFirstPart = listElements.slice(0, insertUpSellingAfterNumberOfPosts);
      listElementsSecondPart = listElements.slice(insertUpSellingAfterNumberOfPosts);
    } else {
      listElementsFirstPart = listElements;
    }
    return (
      <BlogBase pageTitle={makePageTitle(intl.formatMessage(pageTitle))}>
        <div className="blog-page">
          <div className="blog-entry-list">{listElementsFirstPart}</div>
        </div>
        <BlogUpselling deviceType={deviceType} />
        <div className="blog-page">
          {listElementsSecondPart && <div className="blog-entry-list">{listElementsSecondPart}</div>}
          <div className="px-2 px-md-5">
            <BlogPagination
              total={meta.pagination.total}
              limit={meta.pagination.pageSize}
              page={currentPage}
              getURL={getPaginationURL}
            />
          </div>
        </div>
      </BlogBase>
    );
  }
);
